import React from "react";

const sections = ["home", "about", "work", "skills", "testimonials", "footer"];

const NavigationDots = ({ active }) => (
  <div className="flex flex-col gap-4 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full p-3 shadow-glow">
    {sections.map((item) => {
      const isActive = active === item;
      return (
        <a
          href={`#${item}`}
          key={item}
          className="relative group"
          aria-label={`Jump to ${item}`}
        >
          <span
            className={`block w-3 h-3 rounded-full transition-all duration-200 ${
              isActive ? "bg-primary scale-110 ring-2 ring-primary/40" : "bg-white/50 group-hover:bg-white"
            }`}
          />
          <span className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 whitespace-nowrap px-2 py-1 rounded-md bg-black/80 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
            {item}
          </span>
        </a>
      );
    })}
  </div>
);

export default NavigationDots;
